// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CKoD","type":"styles_type__34TtC","choices":"styles_choices__2CyyD"};